<template>
  <div class="h-fill bg-f">
    <template v-if="!$parent.appInner && openFromAppInner && purchasedCard">
      <div class="display-flex justify-content-center pd-t-80">
        <div class="text-align-center">
          <div>
            <van-icon name="checked" class="c-app-green fs-100"/>
          </div>
          <div>
            支付成功，请返回APP下载资源！
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="card.createAt">
      <div id="div_menu" class="z-index-99 fs-12 justify-content-center
       text-align-center pd-10 position-fixed b-0 r-5 column" style="height: 40%">
        <div @click="changeIndex('card')"
             :class="index=='card' || index=='intro'?'text-strong div-index':'no-div-index'"
             class="h-30 w-30 pd-8 bdr-circular justify-content-center align-items-center c-f mg-b-8">
          介绍
        </div>
        <div @click="changeIndex('menu')"
             :class="index=='menu'?'text-strong div-index':'no-div-index'"
             class="w-30 h-30 pd-8 bdr-circular justify-content-center align-items-center c-f mg-b-8">
          目录
        </div>
        <div @click="changeIndex('review')"
             :class="index=='review'?'text-strong div-index':'no-div-index'"
             class="w-30 h-30 pd-8 bdr-circular justify-content-center align-items-center c-f">
          预览
        </div>
        <!--        <div @click="changeIndex('recommend')"
                     :class="index=='recommend'?'text-strong div-index':'no-div-index'"
                     class="h-30 pd-10 bdr-circular justify-content-center align-items-center c-f mg-b-20">
                  推荐
                </div>-->
      </div>
      <div class="bg-f position-fixed l-0 r-0 t-0 z-index-999">
        <div :class="mScrollY > 1 ? 'shadow-2':''"
             class="justify-content-space-between align-items-center pd-l-15 pd-r-15 h-30">
          <div></div>
          <div class="align-items-center fs-14 c-8">
            <strong class="c-app-green" @click="onBuyKnowClick">购买必读</strong>
            <div class="mg-l-8 mg-r-8">|</div>
            <div @click="onShareClick">分享</div>
            <div class="mg-l-8 mg-r-8">|</div>
            <!--<div v-if="!$parent.appInner || $parent.isAndroid" class="mg-l-5 mg-r-5">|</div>-->
            <div @click="onReportClick">举报</div>
          </div>
        </div>
      </div>
      <div id="card" ref="card" class="pd-l-15 pd-r-15 pd-t-35 pd-b-10">
        <div class="justify-content-space-between ">
          <div class="fs-18 flex-1 lh-28">
          <span v-if="card.mark" class="pd-l-6 pd-r-6 display-inline-block lh-22 h-22 bdr-2 fs-12 mg-r-5"
                style="background: linear-gradient(51deg, #262626 0%, #545454 100%);color: #FFC680;vertical-align: middle;"
          >{{ card.mark }}</span>
            <span class="text-strong c-64" style="vertical-align: middle;">{{ card.title }}</span>
          </div>
        </div>
        <div class="mg-t-10 bdr-10 pd-10" style="box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
          <div class="justify-content-space-between">
            <div class="align-items-center fs-12">
              <div>大小 {{ formatFileSize }}</div>
              <div class="mg-l-5 mg-r-5">|</div>
              <template v-if="card.cardCount > -1">
                <div>卡片 {{ card.cardCount }}</div>
              </template>
              <div class="c-app-orange" v-else>免费</div>
            </div>
            <div class="align-items-center fs-12 c-9">
              <div class="c-app-orange fs-14" v-if="card.price > 0">
                <template v-if="$parent.isIos && $parent.appInner">{{ card.price / 100 }}资源币</template>
                <template v-else>￥{{ card.price / 100 }}</template>
              </div>
            </div>
          </div>
          <div class="fs-12 c-9 align-items-center mg-t-10">
            更新：{{ card.editAt ? card.editAt : card.createAt }}
          </div>
          <div class="h-1 mg-t-10 mg-b-4" style="border-bottom: 1px #ccc dashed"></div>
          <div class="justify-content-space-between align-items-center mg-t-10" @click="onUserClick">
            <div class="align-items-center">
              <img :src="userAvatar" class="w-30 h-30 bdr-circular border-2 bdc-e"/>
              <div class="fs-12 mg-l-10">{{ userNickname }}</div>
            </div>
            <div class="fs-12 c-9">
              查看作者主页
              <van-icon name="arrow"/>
            </div>
          </div>
        </div>
        <!--        <div class="justify-content-space-between mg-t-10">
                  <div class="c-7">
                    <div v-if="!card.scoreNew" class="text-align-center fs-14">
                      <div v-if="card.evaluateUserCount > 5">
                        <div>{{ card.score }} 评分</div>
                        &lt;!&ndash;<div class="fs-12 c-9 mg-t-2">{{card.evaluateUserCount}}人评分</div>&ndash;&gt;
                      </div>
                      <div v-else class="c-9">
                        累计中
                      </div>
                      <div v-if="card.evaluateUserCount >= 5" class="mg-t-4 mg-l-4">
                        <van-rate size="14" allow-half v-model="card.score" color="#FFB904" readonly/>
                      </div>
                      <div v-else class="mg-t-4 mg-l-4">
                        <van-rate size="14" allow-half color="#cccccc" readonly/>
                      </div>
                    </div>
                    <div v-else class="fs-12">
                      <div class="pd-b-5">
                        <div class="display-inline-block mg-r-5">内容质量</div>
                        <van-rate size="14" allow-half v-model="card.qualityScore" color="#FFB904" readonly/>
                      </div>
                      <div class="pd-b-5">
                        <div class="display-inline-block mg-r-5">界面美观</div>
                        <van-rate size="14" allow-half v-model="card.uiScore" color="#FFB904" readonly/>
                      </div>
                      <div>
                        <div class="display-inline-block mg-r-5">售后服务</div>
                        <van-rate size="14" allow-half v-model="card.afterSalesScore" color="#FFB904" readonly/>
                      </div>
                    </div>
                  </div>
                  <div class="align-items-center">
                    <div>
                      <div class="pd-8 fs-12 pd-r-20 pd-l-20 bg-app-orange c-f bdr-4" @click="subScore">评分</div>
                      <van-popup v-model="showScore" round closeable style="width: 75%">
                        <div class="bg-f pd-20">
                          <div class="fs-18 mg-t-20">
                            <div class="pd-b-20 mg-l-10">
                              <div class="mg-r-5 display-inline-block">资源内容质量</div>
                              <van-rate size="18" v-model="score.quality_score" color="#FFB904"/>
                            </div>
                            <div class="pd-b-20 mg-l-10">
                              <div class="display-inline-block mg-r-5">卡片界面美观</div>
                              <van-rate size="18" v-model="score.ui_score" color="#FFB904"/>
                            </div>
                            <div class="pd-b-20 mg-l-10">
                              <div class="display-inline-block">作者提供售后</div>
                              <div class="display-inline-block">
                                <van-radio-group v-model="score.is_after_sales" class="align-items-center">
                                  <van-radio class="mg-l-6 mg-r-15" name="1">是</van-radio>
                                  <van-radio name="2">否</van-radio>
                                </van-radio-group>
                              </div>
                            </div>
                            <div class="pd-b-20 mg-l-10" v-if="score.is_after_sales==1">
                              <div class="display-inline-block mg-r-5">作者售后服务</div>
                              <van-rate size="18" v-model="score.after_sales_score" color="#FFB904"/>
                            </div>
                            <van-field
                                class="fs-16"
                                type="textarea"
                                v-model="score.score_content"
                                placeholder="说点什么吧"
                                rows="3"
                                border
                                autosize
                                maxlength="50"
                                show-word-limit
                            />
                            <div class="pd-8 pd-r-20 pd-l-20 bg-app-orange text-align-center c-f bdr-4"
                                 @click="saveScore">
                              评价
                            </div>
                          </div>
                        </div>
                      </van-popup>
                    </div>
                  </div>
                </div>-->
      </div>
      <!--下载过或者购买过-->
      <template v-if="underwayList.length > 0">
        <div class="mg-l-15 mg-r-15 mg-b-10 bdr-10" style="box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);">
          <div class="justify-content-space-between align-items-center pd-l-15 pd-r-15 fs-12"
               style="border-bottom: 1px #e8e8e8 solid">
            <div><span class="c-app-red">{{ underwayUsers }}</span>人在拼团，可直接参与</div>
            <div class="c-9 pd-t-10 pd-b-10" @click="showAllUnderwayList = true">查看全部&gt;</div>
          </div>
          <div class="justify-content-space-between fs-12 pd-15">
            <div class="align-items-center">
              <img :src="underwayList[randomUnderwayIndex].avatar" class="w-30 h-30 bdr-circular mg-r-10"/>
              <div>
                {{ underwayList[randomUnderwayIndex].nickname }}
              </div>
            </div>
            <div class="align-items-center">
              <div class="mg-r-10">
                <div class="text-align-right">还差<span
                    class="c-app-red">{{ underwayList[randomUnderwayIndex].quota }}</span>人
                </div>
                <div>剩余 {{ underwayList[randomUnderwayIndex].countDownTxt }}</div>
              </div>
              <div class="bg-app-orange c-f bdr-5 pd-5" @click="onUnderwayTeamClick(underwayList[randomUnderwayIndex])">
                去拼团
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="pd-b-15 pd-l-15 pd-r-15 position-relative">
        <template v-if="card.contact.length > 5">
          <div
              v-if="(card.price > 0 && card.purchased) || (card.price === 0 && card.downloadTimes > 0) || card.owner"
              class="pd-10  fs-14 bg-f3f bdr-5">
            <div v-if="card.purchased && card.purchasedExpiredDate !== null" class="c-app-red mg-b-10">
              <template v-if="!card.purchasedExpired">
                您已获得此资源，获得更新有效期至<b>{{ card.purchasedExpiredDate }}</b> <a class="c-app-blue"
                                                                                         @click="showPurchasedExpiredExplain = true">点此查看说明</a>
              </template>
              <p v-else class="fs-16">
                您的资源更新有效期已过，只能下载作者在<b>{{ card.purchasedExpiredDate }}</b>之前发布的版本，如需续期请联系作者
                <a class="c-app-blue" @click="showPurchasedExpiredExplain = true">点此查看说明</a>
              </p>
            </div>
            <div>
              作者联系方式：{{ card.contact }}
            </div>
          </div>
          <div v-else class="pd-15 fs-12 bg-f3f text-align-center bdr-5 c-app-green mg-b-10">
            <van-icon name="closed-eye"/>
            作者提供售后，购买后可见
          </div>
        </template>
        <div id="intro" ref="intro">
          <div class="bdr-6 fs-14 c-app-green text-align-center">--- 介绍 ---</div>
          <div class="mg-t-10 card-content" style="min-height: 100px" v-if="card.content"
               v-html="card.content"></div>
          <div class="mg-t-10 fs-14 c-9 text-align-center lh-60" v-if="card.cardId && !card.content">暂无介绍</div>
        </div>
        <div id="menu" ref="menu">
          <div class="pd-15 bdr-6 fs-14 bg-f3f c-app-green text-align-center">
            --- 目录 ---
          </div>
          <div v-if="allDecks">
            <deck-item class="mg-t-10 mg-b-10 pd-t-10" :decks="allDecks" :activedid="activeDid"></deck-item>
          </div>
          <div class="mg-t-0 c-9 fs-14 text-align-center lh-60" v-else>
            暂无目录
          </div>
        </div>
        <div id="review" ref="review">
          <div class="pd-15 bdr-6 fs-14 bg-f3f c-app-green text-align-center">
            --- 预览 ---
          </div>
          <template v-if="preview.cardList">
            <div class="pd-5 mg-t-10 justify-content-space-between flex-wrap">
              <div v-for="(item,i) in preview.cardList" class="mg-b-10 bdr-10 bg-f h-140" @click="onPreview(item,i)"
                   style="overflow: hidden;flex-basis: calc(50% - 6px);box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);">
                <div class="mg-10 fs-14 c-64 text-ellipsis-1 text-strong">
                  {{ item.sfld }}
                </div>
                <div class="fs-12 mg-10 lh-18 c-9 text-ellipsis-5">
                  {{ item.fldsText }}
                </div>
              </div>
            </div>
            <van-popup v-model="isPreview" closeable round
                       position="bottom"
                       :style="{ height: '90%' }">
              <card-viewer :did="preview.cardList[0].did"
                           :cardId="card.cardId"
                           @previewClose="previewClose"
                           :isPreview="isPreview"
                           :cardList="preview.cardList"
                           :currentCardIndex="currentCardIndex"
                           :currentEditCard="currentEditCard"
              ></card-viewer>
            </van-popup>
          </template>
          <template v-else>
            <div class="mg-t-10 fs-14 c-9 text-align-center lh-60">暂无预览</div>
          </template>
        </div>
      </div>
      <div class="h-1 bg-d"></div>
      <div id="buyKnow">
        <div v-if="card.free != 1" class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          购买权益：本资源购买后永久支持下载
          <span v-if="card.subscribeDate == '1year'">，1年更新支持</span>
          <span v-else-if="card.subscribeDate == '2year'">，2年更新支持</span>
          <span v-else-if="card.subscribeDate == '3year'">，3年更新支持</span>
          <span v-else-if="card.subscribeDate == '3month'">，3个月更新支持</span>
          <span v-else-if="card.subscribeDate == '6month'">，6个月更新支持</span>
          <span v-else-if="card.subscribeDate">，{{ card.subscribeDate }}前更新支持</span>
          <span v-else>，永久更新支持</span>。如有其他疑问可购买后通过售后联系方式联系作者
        </div>
        <div v-if="card.free != 1" class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          使用说明：使用资源时会进行设备和IP检测，仅限您本人使用，请勿与他人合用资源避免出现无法使用的问题。
        </div>
        <div class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          退款说明：若您是付费购买此资源，由于虚拟产品的特殊性不支持无理由退款，商品质量问题2天内可向平台客服申请退款，逾期请联系作者提供售后自行协商沟通。
        </div>
        <div class="fs-14 mg-15">
          <van-icon name="warning-o" color="#51C027"/>
          版权声明：本APP【资源商店】模块只作为资源分发平台全部资源均由用户制作，平台不参与售卖以及不存在任何抽成盈利行为，用户上传时已签《版权责任承诺书》自行承担版权责任，若此资源侵犯了知识产权且您是版权方请发送反馈信件至<strong>ankichinas@163.com</strong>联系平台，感谢理解！
        </div>
      </div>
      <div class="h-200"></div>
      <div class="position-fixed b-0 w-fill safe-bottom" style="">
        <div v-if="card.deleted === 1">
          <div class="bdr-50 bg-app-red text-align-center lh-50 c-f flex-1">该资源已被删除</div>
        </div>
        <div v-else-if="card.status === 2 || card.status === 3">
          <div class="bdr-50 bg-app-red text-align-center lh-50 c-f flex-1">该资源已下架</div>
        </div>
        <div v-else-if="team && team.status == 1">
          <div @click="onTeamDetailClick" class="bg-app-orange text-align-center lh-60 c-f flex-1">
            查看拼团（{{ team.payCount }}/{{ team.users }}）
          </div>
        </div>
        <div v-else class="display-flex align-items-center">
          <div v-if="!purchasedCard && unSupportPlatform()" class="bg-a text-align-center lh-60 c-f flex-1">
            此卡牌暂不支持该系统
          </div>
          <template v-else-if="!purchasedCard">
            <div v-if="!$parent.appInner || !$parent.isIos"
                 class="mg-l-10 mg-b-10 pd-l-20 pd-r-20 bdr-50 fs-14 c-f bg-app-blue lh-50"
                 @click="onInputExchangeCodeClick"
                 style="background-color: #CCFFF0">兑换码
            </div>
            <div v-if="card.teamInfo.length > 0" class="flex-1 display-flex align-items-center">
              <div
                  class="bdr-50 mg-l-10 mg-b-10 mg-r-5 flex-2 bg-app-red align-items-center justify-content-center c-f h-50"
                  @click="onDownloadClick">
                <div>
                  <div class="text-align-center">
                    <span v-if="$parent.isIos && $parent.appInner">{{ card.vipPrice / 100 }}资源币</span>
                    <span v-else>￥{{ card.vipPrice / 100 }}</span>
                  </div>
                  <div class="fs-12 text-align-center">立即购买</div>
                </div>
              </div>
              <div
                  class="bdr-50  mg-r-10 mg-b-10 mg-l-5  flex-2 bg-app-orange align-items-center justify-content-center c-f h-50"
                  @click="onTeamOrderClick">
                <div>
                  <div class="text-align-center">
                      <span v-if="$parent.isIos && $parent.appInner">  {{
                          card.teamInfo[0]['vipPrice'] / 100
                        }}资源币</span>
                    <span v-else>  ￥{{ card.teamInfo[0]['vipPrice'] / 100 }}</span>
                  </div>
                  <div class="fs-12 text-align-center">发起拼团</div>
                </div>
              </div>
            </div>
            <div v-else class="bdr-50 mg-10 bg-app-orange text-align-center lh-50 c-f flex-1"
                 @click="onDownloadClick">
              <div>
                <span v-if="$parent.isIos && $parent.appInner">{{ card.vipPrice / 100 }}资源币购买</span>
                <span v-else>￥ {{ card.vipPrice / 100 }}购买</span>
              </div>
            </div>
            <!--            <div style="background-color: #3E3737; color: #FCAE16"
                             v-if="card.vipDiscountEnable && !card.isForeverVip && !card.isVip"
                             class="pd-l-10 pd-r-10 lh-60 fs-14 text-align-center" @click="toVip">立即开通
                        </div>-->
          </template>
          <template v-else>
            <div class="bdr-50 mg-10 bg-app-green text-align-center lh-50 c-f flex-1" @click="onDownloadClick">
              下载导入
            </div>
          </template>
        </div>
      </div>

      <van-popup v-model="downloadApp">
        <div class="bg-f w-300 pd-20 bdr-15">
          <div>
            <h1 class="text-align-center fs-20">请前往Anki记忆卡内下载该资源!</h1>
          </div>
          <div>
            <div class="text-align-center c-9 fs-16">
              打开APP -> 点击卡牌资源 -> 搜索该资源
            </div>
            <div>
              <div class="w-fill mg-t-20 fs-18 lh-44 text-align-center bg-app-green c-f bdr-22"
                   @click="onStartUpAppClick">前往APP
              </div>
            </div>
          </div>
        </div>
      </van-popup>
      <van-dialog v-model="showBuyKnow">
        <div v-html="buyKnowHtml"></div>
      </van-dialog>
      <van-dialog v-model="showPurchasedExpiredExplain" title="更新有效期说明" show-cancel-button
                  confirmButtonText="知道了">
        <div class="pd-20 fs-14 lh-22">
          在 {{ card.purchasedExpiredDate }} 之前若作者更新了此资源您可以进行下载更新，若作者于此日期之后更新的卡片您无法下载，只能下载更新日期前的旧版本。续期或者对此规则有疑问请联系作者
        </div>
      </van-dialog>
      <van-dialog v-model="showPayResult" title="支付提示" show-cancel-button confirmButtonText="已支付"
                  cancelButtonText="未支付" @confirm="onPayConfirm" @cancel="onPayCancel">
        <div class="mg-20">
          <div class="text-align-center">是否已支付完成？</div>
          <div v-if="$parent.appInner && copyPayUrl" class="c-app-red fs-14 mg-t-20">正在发起支付，若无反应请复制链接到浏览器打开<span
              class="c-app-blue"
              @click="onCopyPayUrlClick">点我复制链接</span>
          </div>
        </div>
      </van-dialog>
      <van-dialog v-model="showInputExchangeCode" title="使用兑换码获取" show-cancel-button confirmButtonText="确定"
                  @confirm="onConfirmExchangeClick">
        <div class="mg-20">
          <van-field v-model="exchangeCode" placeholder="请输入兑换码"/>
        </div>
      </van-dialog>
      <van-popup v-model="showAllUnderwayList" :close-on-click-overlay="false">
        <div class="w-350">
          <div class="bg-f pd-10 bdr-10">
            <div class="text-align-center fs-14">全部拼团</div>
            <div class="" style="max-height: 500px;overflow-y: scroll">
              <div v-for="item in underwayList" class="justify-content-space-between fs-12 pd-15 "
                   style="border-bottom: 1px solid #e8e8e8">
                <div class="align-items-center">
                  <img :src="item.avatar" class="w-30 h-30 bdr-circular mg-r-10"/>
                  <div>
                    {{ item.nickname }}
                  </div>
                </div>
                <div class="align-items-center">
                  <div class="mg-r-10">
                    <div class="text-align-right">还差<span class="c-app-red">{{ item.quota }}</span>人</div>
                    <div>剩余 {{ item.countDownTxt }}</div>
                  </div>
                  <div @click="onUnderwayTeamClick(item)" class="bg-app-orange c-f bdr-5 pd-5">
                    去拼团
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-align-center">
            <span @click="showAllUnderwayList = false"
                  class="display-inline-block mg-t-20 border-1 bdc-f bdr-circular w-20 lh-20 c-f">×</span>
          </div>
        </div>
      </van-popup>
    </template>
    <van-action-sheet
        v-model="showPayOptions"
        cancel-text="取消"
        close-on-click-action>

      <div class="bg-f pd-20 fs-18">
        <div v-if="orderType == 'team'" class="mg-b-15 c-4 fs-12 text-align-center">
          拼团规则： <b>{{ card.teamInfo[0].users }}</b> 人成团 <b>{{ card.teamInfo[0].timeout }}</b> 小时内未成团全额退款
        </div>
        <div class="fs-14 text-align-center mg-b-30 text-strong">请选择支付方式</div>
        <div @click="onPaySelectClick('alipay_h5')" class="justify-content-center align-items-center pd-10">
          <img src="/h5/static/images/alipay.png" class="w-20">
          <div class="w-120 text-align-center">支付宝</div>
        </div>
        <div class="h-1 bg-f3f mg-t-15 mg-b-10"></div>
        <div @click="onPaySelectClick('wechat')" class="justify-content-center align-items-center pd-10 mg-t-10">
          <img src="/h5/static/images/wechatpay.png" class="w-20">
          <div class="w-120 text-align-center">微信支付</div>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet
        v-model="showAppCoinPay"
        cancel-text="取消"
        close-on-click-action>
      <div class="bg-f pd-20">
        <div class="fs-14 mg-b-30 justify-content-space-between">
          <b>{{ this.orderType == 'team' ? '发起拼团' : '立即购买' }}</b>
          <div class="c-app-green" @click="onRechargeAppCoinClick">资源币充值&gt;</div>
        </div>
        <div class="justify-content-space-between">
          <div>您可用资源币余额：</div>
          <b>{{ appCoin }}</b>
        </div>
        <div class="justify-content-space-between mg-t-10">
          <div>本次将消耗资源币：</div>
          <b>{{ prePayCoin / 100 }}</b>
        </div>
        <div class="h-1 bg-f3f mg-t-20 mg-b-20"></div>
        <div v-if="orderType == 'team'" class="mg-t-10 c-4 fs-12 text-align-center">
          拼团规则： <b>{{ card.teamInfo[0].users }}</b> 人成团 <b>{{ card.teamInfo[0].timeout }}</b> 小时内未成团全额退款
        </div>
        <div class="bdr-50 mg-10 bg-app-green text-align-center lh-50 c-f flex-1" @click="onAppCoinPayClick">
          {{ prePayCoin / 100 > appCoin ? '余额不足，立即充值' : '确认支付' }}
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>

import cardItem from '../components/cardItem'
import deckItem from '../components/deckItem'
import cardViewer from "../components/cardViewer";

import request from '../libs/api.request'
import util from '../libs/util'
import storage from "../libs/storage";

export default {
  name: "Card",
  components: {
    cardViewer,
    cardItem,
    deckItem,
  },
  data() {
    return {
      index: 'card',
      active: 0,
      activeDid: null,
      allDecks: {},
      isPreview: false,
      showScore: false,
      score: {
        'quality_score': 0,
        'ui_score': 0,
        'is_after_sales': '1',
        'after_sales_score': 0,
        'score_content': '',
      },
      currentCardIndex: 0,//当前点击的卡牌的索引
      currentEditCard: {},
      cardId: this.$route.params.cardId,
      morePayWay: false,
      downloading: false,
      card: {},
      team: null,
      userAvatar: '',
      userNickname: '',
      userOther: [],
      recommend: [],
      coin: '-',
      appCoin: '-',
      prePayCoin: 0,
      selectPackage: 0,
      rechargePackage: [],
      hasImport: false,
      showPayResult: false,
      showAllUnderwayList: false,
      copyPayUrl: '',
      showPayOptions: false,
      showAppCoinPay: false,
      exchangeCode: "",
      preview: {},
      showAllPreview: false,
      orderType: '',//订单类型  卡牌或者积分
      openFromAppInner: false, //从app复制打开
      canDownload: false,//是否允许非APP内下载免费卡牌
      downloadApp: false,
      underwayList: [],
      randomUnderwayTeam: null,
      underwayUsers: 0,
      underwayCountDowner: null,
      mScrollY: 0,
      showInputExchangeCode: false,
      showBuyKnow: false,
      buyKnowHtml: '',
      showPurchasedExpiredExplain: false,
    }
  },
  computed: {
    formatFileSize() {
      if (this.card.fileSize > 1024 * 1024) {
        return (this.card.fileSize / (1024 * 1024)).toFixed(1) + "MB"
      } else if (this.card.fileSize > 1024) {
        return (this.card.fileSize / (1024)).toFixed(1) + "KB"
      } else {
        return this.card.fileSize + "B"
      }
    },
    purchasedCard() {//已购
      return this.card.owner || this.card.price == 0 || this.card.purchased;
    }
  },
  watch: {
    $route(to, from) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.cardId = this.$route.params.cardId;
      this.getData();
    },
    isPreview: {
      handler(newVal) {
        // 背景滚动由 van-popup 的 lock-scroll 统一管理，勿在此处改写 body.style，
        // 否则会与 Popup 关闭动画时的解锁逻辑竞态，导致偶现整页无法滚动。
        if (!newVal && this.active == 2) {
          this.active = 0;
        }
      },
      deep: true,
    },
  },
  methods: {
    onInputExchangeCodeClick() {
      if (this.$parent.loginUser) {
        this.showInputExchangeCode = true;
      } else {
        this.$parent.login();
      }
    },
    onConfirmExchangeClick() {
      request.request({
        url: '/card/useExchangeCode',
        method: 'post',
        data: {
          cardId: this.cardId,
          code: this.exchangeCode
        }
      }).then((data) => {
        this.getData();
        this.$dialog.alert({message: '兑换成功，你可以下载卡牌了！'}).then(() => {
        })
      }).catch((data) => {
        this.$toast(data.message);
      })
    },
    onRechargeAppCoinClick() {
      gotoAppCoin.postMessage("");
    },
    changeIndex(divId) {
      this.index = divId;
      const targetElement = this.$refs[divId];
      if (targetElement) {
        // 获取目标元素的位置
        const targetPosition = targetElement.getBoundingClientRect().top;
        // 计算窗口可视区域顶部距离页面顶部的距离（考虑了可能存在的固定头部等）
        const viewportTop = window.pageYOffset || document.documentElement.scrollTop;
        // 计算目标位置与当前滚动位置的差值，减去45像素作为最终的滚动位置
        const offsetPosition = targetPosition + viewportTop - 3;
        // 使用平滑滚动到计算出的位置
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },
    onBuyKnowClick() {
      this.buyKnowHtml = document.getElementById('buyKnow').innerHTML;
      this.showBuyKnow = true;
    },
    subScore() {
      request.request({
        url: 'card/subScore',
        data: {card_id: this.cardId},
        method: 'post'
      }).then((data) => {
        this.showScore = true;
      }).catch((err) => {
        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
          return;
        }
        this.$toast(err.message)
      })
    },
    saveScore() {
      request.request({
        url: 'card/score',
        data: {...{card_id: this.cardId}, ...this.score},
        method: 'post'
      }).then((data) => {
        this.score = {
          'quality_score': 0,
          'ui_score': 0,
          'after_sales_score': 0,
          'score_content': '',
        };
        this.showScore = false;
        this.$toast('评价已提交！');
      }).catch((err) => {
        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
          return;
        }
        this.$toast(err.message)
      })
    },
    toVip() {
      if (!this.$parent.loginUser) {
        this.$parent.login();
      } else {
        if (this.$parent.isIos && this.$parent.appInner) {
          if (util.compareVersionIfMax(this.$parent.appVersion, '1.13.2')) {
            akBridge.callHandler("openVIPPage");
          } else {
            this.$dialog.alert({message: '咦跳不过去了，请返回app设置页面查看详情哦'}).then(() => {
            })
          }
        } else {
          this.$router.push({'path': '/vip', query: {chan: 1}})
        }
      }
    },
    onTeamDetailClick() {
      this.$router.push({'path': '/team/' + this.team.teamId})
    },
    unSupportPlatform() {
      if (
          this.$parent.appInner &&
          this.card.platform.length > 0) {
        let p = this.$parent.isIos ? 2 : 1;
        return this.card.platform.indexOf(p) === -1;
      }

      return false;
    },
    onPaySelectClick(payType) {
      if (this.downloading) {
        return;
      }

      if (payType.indexOf("wechat") > -1) {
        if (util.inWechatPC()) {
          this.$dialog.alert({message: "请使用手机版微信打开链接支付"});
          return;
        }
        payType = util.inWechat() ? 'wechat_gzh' : 'wechat_h5'
      } else if (payType.indexOf("alipay") > -1) {
        if (util.inWechat()) {
          this.$parent.showCommonMask("微信内不支持支付宝", "请打开外部浏览器进行支付");
          return;
        }
      } else {
        this.$dialog.alert({
          message: '错误的支付方式',
        });
      }

      this.downloading = true;
      request.request({
        url: 'card/order',
        data: {
          isMobile: /windows phone|iphone|android/ig.test(window.navigator.userAgent) ? 1 : 0,
          cardId: this.cardId,
          returnUrl: location.href,
          appInner: this.$parent.appInner ? 1 : 0,
          payType: payType,
          orderType: this.orderType,
          wxOpenId: this.$parent.wxOpenId
        },
        method: 'post'
      }).then((data) => {
        this.downloading = false;
        if (this.orderType === 'team') {
          localStorage.setItem("jumpTeamOrder", 1);
        }
        if (util.inWechat()) {
          WeixinJSBridge.invoke('getBrandWCPayRequest', data.payData, (res) => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              this.showPayOptions = false;
              this.$toast.loading({
                loadingType: 'spinner',
                message: '正在查询支付结果',
                duration: 60000,
                overlay: true
              });
              setTimeout(() => {
                location.reload();
              }, 3000);
            }
          });
        } else {
          this.copyPayUrl = data.copyPayUrl;
          setTimeout(() => {
            this.showPayResult = true;
            this.showPayOptions = false;
          }, 800);
          location.assign(data.payUrl);
        }
      }).catch((err) => {
        setTimeout(() => {
          this.downloading = false;
        }, 600);
        this.$toast(err.message);
        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
        }
      })

    },
    onPayConfirm() {
      let href = location.href;
      this.$toast.loading({loadingType: 'spinner', message: '', duration: 8000, overlay: true});
      setTimeout(() => {
        location.replace(href.replace(new RegExp("h5pay_redirect=", "gm"), 'h5pay_redirected='));
      }, 1500);
    },
    onPayCancel() {
      let href = location.href;
      location.replace(href.replace(new RegExp("h5pay_redirect=", "gm"), 'h5pay_redirected='));
    },
    onBackClick() {
      this.$router.push({path: '/'});
    },
    onStartUpAppClick() {
      if (!this.$parent.isIos) {
        setTimeout(() => {
          this.$router.push({path: '/download-app'})
        }, 1000);
        location.href = 'scheme://ankichina/home';
      } else {
        location.href = 'https://apps.apple.com/cn/app/id1540528340';
      }
    },
    onEvaluateClick(val) {
      if (this.$parent.loginUser) {
        request.request({
          url: 'card/evaluate',
          data: {cardId: this.cardId, value: val},
          method: 'post'
        }).then((data) => {
          this.card.evaluateUserCount = data.evaluateUserCount
          this.card.score = data.score
          this.card.evaluated = true
          this.$toast('评价已提交！');
        }).catch((err) => {
          if (err.code === 401 || err.code === 403) {
            this.$parent.login();
            return;
          }
          this.$toast(err.message)
        })
      } else {
        this.$parent.login();
      }
    },
    onTeamOrderClick() {
      if (!this.$parent.loginUser) {
        this.$parent.login();
        return;
      }

      this.orderType = 'team';
      if (this.$parent.appInner && this.$parent.isIos) {
        this.prePayCoin = this.card.teamInfo[0]['vipPrice'];
        this.showAppCoinPay = true;
        this.getAppCoin();
      } else {
        this.showPayOptions = true;
      }
    },
    onDownloadClick() {
      if (util.inWechat() && this.purchasedCard) {
        this.$parent.showCommonMask("微信内不支持下载", "请通过外部浏览器打开下载");
        return;
      }
      if (this.$parent.isIos && util.inQQ() && this.purchasedCard) {
        this.$parent.showCommonMask("QQ内不支持下载", "请通过外部浏览器打开下载");
        return;
      }

      if (this.$parent.loginUser) {
        if (this.card.owner || this.card.purchased) {
          this.onRealDownloadClick();
          return;
        }

        if (this.card.price > 0) {
          this.orderType = 'card';
          if (this.$parent.appInner && this.$parent.isIos) {
            this.prePayCoin = this.card.vipPrice;
            this.showAppCoinPay = true;
            this.getAppCoin();
          } else {
            this.showPayOptions = true;
          }
        } else {
          if (this.$parent.appInner || this.canDownload) {
            this.onRealDownloadClick();
          } else {
            this.downloadApp = true;
          }
        }
      } else {
        this.$parent.login();
      }
    },
    onRealDownloadClick(ignoreBigFile) {
      if (this.downloading) {
        return;
      }

      if (this.card.fileSize > 1024 * 1024 * 500 && !ignoreBigFile) {
        this.$dialog.confirm({
          message: '该文件超过500M下载时间可能较长，若长时间下载不成功可尝试用电脑浏览器访问【Anki中文资源网】登录下载再导入手机',
          confirmButtonText: '开始下载'
        }).then(() => {
          this.onRealDownloadClick(true);
        });
        return;
      }

      this.downloading = true;
      let requestStatus = 0;
      setTimeout(() => {
        if (requestStatus === 0) {
          if (this.card.fileSize > 1024 * 1024 * 30) {
            this.$toast.loading({
              loadingType: 'spinner',
              message: '生成下载链接中，文件较大请耐心等候~',
              duration: 90000,
              overlay: true
            });
          } else {
            this.$toast.loading({
              loadingType: 'spinner',
              message: '生成下载链接中，请稍候',
              duration: 60000,
              overlay: true
            });
          }
        }
      }, 1200);
      request.request({url: 'card/downloadUrl?cardId=' + this.cardId}).then((data) => {
        requestStatus = 1;
        this.$toast.clear();
        setTimeout(() => {
          this.downloading = false;
          if (!this.$parent.appInner) {
            this.$toast('准备下载文件');
          }
        }, 500);
        this.coin = data.coin;
        this.appCoin = data.appCoin;
        storage.setUserInfo({coin: this.coin});
        this.card.purchased = true;
        try {
          downloadFile.postMessage(JSON.stringify({
            url: data.url,
            resourceCardId: this.cardId
          }));
        } catch (e) {
          this.$toast('调起下载失败')
        }

      }).catch((err) => {
        requestStatus = 1;
        this.$toast.clear();
        setTimeout(() => {
          this.downloading = false;
        }, 500);

        if (err.code === 401 || err.code === 403) {
          this.$parent.login();
        } else {
          this.$toast(err.message)
        }
      })
    },
    onReportClick() {
      this.$router.push({path: '/report', query: {cardId: this.cardId}})
    },
    getData() {
      let requestStatus = 0;
      setTimeout(() => {
        if (requestStatus === 0) {
          this.$toast.loading({loadingType: 'spinner', message: '', duration: 10000});
        }
      }, 1000);
      request.request({
        url: 'card/detail?cardId=' + this.$route.params.cardId + '&appInner=' + (this.$parent.appInner ? 'yes' : ''),
      }).then(data => {
        requestStatus = 1;
        if (data.team && data.team.status == 1) {
          if (localStorage.getItem("jumpTeamOrder") == '1') {
            this.$router.push({path: '/team/' + data.team.teamId});
            return;
          }
        }

        this.$toast.clear();
        this.userId = data.userId;
        this.userAvatar = data.userAvatar;
        this.userNickname = data.userNickname;
        this.userOther = data.userOther;
        this.recommend = data.recommend;
        this.card = data.card;
        this.team = data.team;
        this.allDecks = data.allDecks;
        this.underwayList = data.underwayList;
        if (this.underwayList && this.underwayList.length > 0) {
          this.randomUnderwayIndex = util.randomNum(0, this.underwayList.length - 1);
        }
        this.underwayUsers = data.underwayUsers;
        this.preview = data.preview;
        document.title = data.card.title;
        document.querySelector('meta[name="keywords"]').setAttribute('content', data.card.title);
        document.querySelector('meta[name="description"]').setAttribute('content', data.card.contentDesc);
        let doAction = sessionStorage.getItem('doAction');
        if (doAction) {
          sessionStorage.removeItem('doAction');
          if (doAction === 'download') {
            setTimeout(() => {
              if (this.card.purchased) {
                this.onDownloadClick();
              } else if (this.team && this.team.payCount >= this.team.users) {
                this.$dialog.alert({
                  message: '正在验证开团结果，请稍等一会刷新页面重试！',
                });
              }
            }, 500)
          } else if (doAction === 'newTeam') {
            this.onTeamOrderClick();
          }
        }

        if (util.inWechat()) {
          this.$parent.doWxShare(this.card.title, this.card.contentDesc,
              "https://file.ankichinas.cn/h5/card/" + this.cardId,
              "https://file.ankichinas.cn/server/static/image/share-icon.jpg");
        }
      }).catch(err => {
        requestStatus = 1;
        this.$toast.clear();
        this.$toast(err.message)
      })
    },
    onShareClick() {
      let shareData = {
        platform: ["QQ", "WEIXIN", "WEIXIN_CIRCLE", "COPY_LINK"],
        link: "https://file.ankichinas.cn/h5/card/" + this.cardId,
        title: this.card.title,
        desc: this.card.contentDesc,
        thumb: "https://file.ankichinas.cn/server/static/image/share-icon.jpg",//缩略图
      };

      // if (akBridge && util.compareVersionIfMax(this.$parent.appVersion, '1.9.32')) {
      //   akBridge.callHandler("socialShare", JSON.stringify(shareData));
      // } else if (typeof AnkiDroidJS !== 'undefined' && util.compareVersionIfMax(this.$parent.appVersion, '3.00.20')) {
      //   AnkiDroidJS.socialShare(JSON.stringify(shareData));
      if (util.inWechat()) {
        this.$parent.showWechatShareMask();
      } else {
        this.$parent.execCopy('https://file.ankichinas.cn/h5/card/' + this.cardId, '链接已复制');
      }
    },
    onCopyPayUrlClick() {
      this.$parent.execCopy(this.copyPayUrl, '链接已复制请前往手机浏览器粘贴支付');
    },
    onTitleClick() {
      this.$router.push({path: '/'})
    },
    onUnderwayTeamClick(team) {
      console.log(team);
      this.$router.push({path: '/team/' + team.teamId})
    },
    onPreview(card, i) {
      this.currentCardIndex = i;
      this.isPreview = true;
    },
    previewClose() {
      this.isPreview = false;
      this.active = 0;
    },
    divMenuElementOutOfViewport() {
      const devSel = document.getElementById('card');
      if (devSel) {
        const rect = devSel.getBoundingClientRect();
        let ret = (
            rect.top > window.innerHeight || // 元素底部完全在视口上方
            rect.bottom > 100 || // 元素顶部完全在视口下方60
            rect.left > window.innerWidth || // 元素右侧完全在视口左侧
            rect.right < 0 // 元素左侧完全在视口右侧
        );
      }
    },
    checkVisibleDivs() {
      let items = ['card', 'intro', 'menu', 'review', 'recommend'];
      let visibleDivIds = [];
      for (let i of items) {
        const divRef = this.$refs[i];
        if (divRef) {
          const divRect = divRef.getBoundingClientRect();
          // 判断div是否至少有一部分在视口内
          if (divRect.top > 0) {
            if (divRect.top <= window.innerHeight) {
              visibleDivIds.push(divRef.id);
            } else {
              if (visibleDivIds.includes(i)) {
                visibleDivIds = visibleDivIds.filter(item => item !== i);
              }
            }
          } else {
            if (divRect.bottom > 0 && divRect.height >= window.innerHeight) {
              visibleDivIds.push(divRef.id);
            } else {
              if (visibleDivIds.includes(i)) {
                visibleDivIds = visibleDivIds.filter(item => item !== i);
              }
            }
          }
        }
      }
      // 可以在这里使用visibleDivIds做进一步的处理，比如更新Vue的数据或状态
      if (visibleDivIds.length > 0) {
        this.index = visibleDivIds[0];
      } else {
        // this.index = visibleDivIds[visibleDivIds.length - 1];
      }
    },
    getAppCoin() {
      request.request({url: 'user/getAppCoin',}).then((data) => {
        this.appCoin = data.coin;
      })
    },
    onAppCoinPayClick() {
      if (this.prePayCoin / 100 > this.appCoin) {
        gotoAppCoin.postMessage("");
        return;
      }

      this.$toast.loading({loadingType: 'spinner', message: '正在处理', duration: 60000, overlay: true});
      request.request({
        url: 'order/makeOrderInfo',
        params: {
          id: (this.orderType === 'team' ? 'team:' : '') + this.cardId + '--anymo',
          prePayCoin: this.prePayCoin,
        },
      }).then((data) => {
        request.request({
          url: 'order/payOrder',
          params: {
            payOrderId: data.order_id,
          }
        }).then((data) => {
          this.$toast.clear();
          this.showAppCoinPay = false;
          if (this.orderType === 'team') {
            localStorage.setItem("jumpTeamOrder", 1);
          }

          this.$toast("支付成功，正在刷新");
          setTimeout(() => {
            location.reload();
          }, 500);
        }).catch((err) => {
          this.$toast.clear();
          this.$toast(err.message)
        })
      }).catch((err) => {
        this.$toast.clear();
        if (err.code === 401 || err.code === 403) {
          this.showAppCoinPay = false;
          this.$parent.login();
          return;
        }
        this.$toast(err.message)
      })

    },
    onUserClick() {
      this.$router.push({path: '/userCenter/' + this.userId})
    },
    handleScroll() {
      this.mScrollY = window.scrollY;
      console.log(this.mScrollY);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    console.log("destroyed");
    if (this.underwayCountDowner) {
      clearInterval(this.underwayCountDowner);
      this.underwayCountDowner = null;
    }
    window.removeEventListener('scroll', this.divMenuElementOutOfViewport);
    window.removeEventListener('scroll', this.checkVisibleDivs);
    window.refreshAppCoin = null;
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    console.log("mounted");
    // 判断是否是开发环境
    if (process.env.NODE_ENV !== 'development' && !this.$parent.appInner) {
      //如果不是在APP内部，则跳转到资源网，如果需要调试 在url加上参数 app-inner=yes 使得 this.$parent.appInner 为 true
      location.replace(location.href.replace(location.host, "file.ankichinas.cn"));
      return;
    }
    window.addEventListener('scroll', this.divMenuElementOutOfViewport, true);
    window.addEventListener('scroll', this.checkVisibleDivs, true);

    window.refreshAppCoin = () => {
      this.getAppCoin();
    }

    this.openFromAppInner = this.$route.query['fromAppInner'] === 'yes';
    this.getData();
    if (this.$parent.loginUser) {
      this.coin = this.$parent.loginUser.coin;
    }

    if (this.$parent.authToken) {
      if (this.$parent.appInner && this.$parent.isIos) {
        this.getAppCoin();
      }
    }

    if (akBridge) {
      akBridge.registerHandler("akSetCardStatus", (responseData) => {
        this.hasImport = parseInt(responseData) === 1;
      });

      setTimeout(() => {
        akBridge.callHandler("akGetCardId", this.cardId)
      }, 10);
    }

    if (this.$route.query['h5pay_redirect'] === 'yes') {
      setTimeout(() => {
        this.showPayResult = true;
      }, 100)
    }

    let shareInfo = this.$route.query['share_info'] || sessionStorage.getItem('share_info');
    this.$cookies.set('currentPreviewCardId', this.cardId);
    if (shareInfo) {
      request.request({
        url: 'card/checkDownload',
        params: {
          cardId: this.cardId,
          shareInfo: shareInfo
        }
      }).then((data) => {
        this.canDownload = data.ret;
      })
    }

    if (!this.underwayCountDowner) {
      this.underwayCountDowner = setInterval(() => {
        if (this.underwayList && this.underwayList.length > 0) {
          for (let i = 0; i < this.underwayList.length; i++) {
            this.underwayList[i].countDown--;
            if (this.underwayList[i].countDown <= 0) {
              this.underwayList[i].countDownTxt = '00:00:00';
            } else {
              let H = parseInt(this.underwayList[i].countDown / 3600);
              let countDownH = H < 10 ? '0' + H : H;
              let M = parseInt((this.underwayList[i].countDown % 3600) / 60);
              let countDownM = M < 10 ? '0' + M : M;
              let S = parseInt(this.underwayList[i].countDown % 60);
              let countDownS = S < 10 ? '0' + S : S;
              this.underwayList[i].countDownTxt = countDownH + ':' + countDownM + ':' + countDownS;
            }
          }
        }
      }, 1000);
    }
  }
}


</script>

<style>

.div-index {
  background-color: #51C027;
}

.no-div-index {
  background-color: rgba(0, 0, 0, 0.75);
}

.safe-bottom {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.van-tab {
  font-size: 16px !important;
  font-weight: bold !important;
}

.arrow-div {
  position: relative;
  background-color: #ffffff;
  border: 0px solid #dddddd;
  margin-bottom: 1px;
}

.arrow-div:before {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  border: 1px solid #ddd;
  border-color: transparent #ddd #ddd transparent;
  transform: rotate(45deg);
  right: 30px;
  bottom: -4px;
  background: #fff;
}

.card-content iframe {
  width: 100%;
  min-height: 350px;
}

</style>
